<app-dialog-title
  title="Wrong blockchain network"
  [canClose]="canClose"
  (closeDialog)="close()">
</app-dialog-title>

@if (!!networksOptions && networksOptions.length > 0) {
  <div class="content g-flex-column g-flex--align-center g-flex--justify-center">
    <div class="disclaimer__desc2 app-btn-small_font-size color-caption info-network">
      {{ 'network.rule-1' | translate }}<br />
      {{ 'network.rule-2' | translate: { network: networksOptions[0].label } }} <br />
      {{ 'network.rule-3' | translate: { network: networksOptions[0].label } }}<br />
    </div>

    @for (net of networksOptions; track net) {
      <button
        class="btn-network app-btn-red-4 pointer"
        (click)="switchNetwork(+net.id)">
        {{ mapNetworkNameToDescription(net.label) }}
      </button>
    }
  </div>
}
